import React from 'react';
import { Link, Navigate} from 'react-router-dom';
import Header from '../components/Frontend/Header';
import Footer from '../components/Frontend/Footer';
import FameWallPte from '../components/Frontend/FameWallPte';
import Testimonial from '../components/Frontend/Testimonial';
import TestimonialVid from '../components/Frontend/VideoPTETestimonial';
import SimpleReactValidator from 'simple-react-validator';
import {store} from 'store/index';
import { setAlert} from 'action/index.js';
import API from "api.js";
import { Helmet } from "react-helmet";
import ReactGA from 'react-ga';
import ReactPixel from 'react-facebook-pixel';
import Slider from "react-slick";
import VideoTuts from '../components/Frontend/VideoTuts';
import VideoTestimonial from '../components/Frontend/VideoNaatiTestimonial';



class Pte extends React.Component {
    constructor(props) {
      super(props);
      this.state = {
        isActive: false,
        name: '',
        email: '',
        phone:'',
        course:'PTE On-Campus',
        lang:'Hindi',
        query:'',
        flag:false,
        loginLock:false,
        readMoreFlag:false
      };
      this.validator = new SimpleReactValidator();
    }
    handleClick = () => {
      this.setState((prevState) => ({
        isActive: !prevState.isActive,
      }));
    };

    componentDidMount() {
        ReactGA.initialize('UA-157984080-1');
        ReactGA.pageview(window.location.pathname + window.location.search);
        ReactPixel.init('2474090032742391');
        ReactPixel.init('197333187452630');
        ReactPixel.pageView();
    }
    submitForm = (e) => {
      e.preventDefault();
      this.hitApi();
    }

    hitApi = async() => {
      if (this.state.loginLock) {
        return ;
      }
      if (!this.validator.allValid()) {
        this.validator.showMessages();
        this.forceUpdate();
        return ;
      }
      this.setState({loginLock:true});

      var bodyFormData = new FormData();
      bodyFormData.set('email', this.state.email);
      bodyFormData.set('name',this.state.name);
      bodyFormData.set('phone',this.state.phone);
      bodyFormData.set('message','Lang: '+this.state.lang+'<br/>course: '+this.state.course+'<br/>Query: '+this.state.query);
      bodyFormData.set('data', 'email: '+ this.state.email+',name: '+this.state.name+',phone: '+this.state.phone+',lang: '+this.state.lang+',course: '+this.state.course+',query: '+this.state.query);
      bodyFormData.set('page', "PTE coaching Sydney");
      let res = null;
      try{
        res = await API({
          method: 'POST',
          url: 'sendOnlinePte',
          data: bodyFormData
        })
      }catch(error) {


      };
      console.log(res)
      if (res?.status === 200) {
        store.dispatch(setAlert({'flag':true,'type':1,'message':res.data.message}));
        this.setState({name:'',email:'',phone:'',course:'PTE On-Campus',query:'',loginLock:false,flag:true})
      }else{
        this.setState({loginLock:false});
      }


  }

  changeReadMore = () =>{
    this.setState({readMoreFlag:!this.state.readMoreFlag})
  }

  changeInput = (e) => {
    let { name, value } = e.target;
    this.setState({ [name] : value });
  }
 render(){
    if (this.state.flag) {
      return (<Navigate to="/thank-you" replace />);
    }


    const settings1 = {
      adaptiveHeight: true,
      dots: true,
      infinite: true,
      speed: 500,
      slidesToShow: 3,
      slidesToScroll: 1,
      autoplay: false,
      autoplaySpeed: 2000,
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1,
            infinite: true,
            dots: true,
          },
        },
        {
          breakpoint: 767,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            infinite: true,
            dots: true,
          },
        },
      ],
    };
    const customslider = {
      dots: false,
      arrows: false,
      infinite: true,
      slidesToShow: 1,
      slidesToScroll: 1,
      autoplay: true,
      autoplaySpeed: 4000,
  };


    return (
    <React.Fragment>
    <Helmet>
        <title>PTE Coaching Classes in Sydney | Language Academy</title>
        <meta name="twitter:title" content="PTE Coaching Classes in Sydney - Language Academy" />
      <meta property="og:title" content="PTE Coaching Classes in Sydney - Language Academy" />
      <meta name="description" content="Join Language Academy's PTE coaching in Sydney for top-notch PTE training. Achieve your goals with comprehensive practice materials and expert instruction." />
      <meta name="twitter:description" content="Are you searching for the best PTE coaching classes in Parramatta that can help you achieve sure-shot success in your exam? Language Academy, the top PTE training institute in Sydney, provides both in-class and online coaching to help the students to improve their scores in the Pearson Test Of English. To get demo classes from the leading PTE Coaching centre, contact at +61 426230061." />
      <meta property="og:description" content="Are you searching for the best PTE coaching classes in Parramatta that can help you achieve sure-shot success in your exam? Language Academy, the top PTE training institute in Sydney, provides both in-class and online coaching to help the students to improve their scores in the Pearson Test Of English. To get demo classes from the leading PTE Coaching centre, contact at +61 426230061." />
    </Helmet>
      <Header />
        <div className="hero-section mt-80">
          <div className="container">
            <div className="row">
            <div className="col-lg-8 col-md-8">
              <div className="hero-content">
              <h1 className="primary-heading mfw-600">
              Achieve your <br className='d-none d-md-block' />Australian Dream<br className='d-none d-md-block' /> with the <span> Best PTE<br className='d-none d-md-block' /> Coaching Classes
                </span>{" "}
                <br className='d-none d-md-block' />
                in Sydney
              </h1>					  
              <p className="sub-heading">
              To hone your English Linguistic Skills, join the top <br className='d-none d-lg-block' />PTE Training Institute, and get 1:1 expert guidance.
              </p>           
              <div className="text-center text-md-start">
                <Link to="/auth/register" className="primary-btn">REGISTER NOW <img src="/images/web-new-images/right-arrow.svg" alt="Register Now" /></Link>
              </div>
              </div>
            </div>
            <div className="col-lg-4 col-md-4">
              <div className="hero-img-wrapper">
              <img
                className="img-fluid"
                src="/images/web-new-images/bannerImg.png"
                alt="LA"
              />
              </div>
            </div>
            </div>
          </div>
        </div>
        <div className="pte-content-section pcs-pte-content">
              <div className="circle-section">
                <div className="container pte-container">
                  <div className="row">
                    <div className="col-md-12 position-relative">
                      <h2 className="primary-heading text-center">
                      PTE Training <br className="d-block" /> in Sydney with <br className="d-block" /> <span className="wpl-badge pte-naati-badge text-white">Language Academy</span>
                      <img
                          className="emoji-img"
                          src="/images/web-new-images/emojis/smile-icon.png"
                          alt="LA"
                        />                  
                      </h2>   
                      <div className="position-relative">
                        <ul className="m-0">
                          <li>                           
                            Sydney has many English Training institutes with top facilities. We are glad that our coaching Language Academy is one such renowned PTE Coaching in Sydney. With our spacious, fully-facilitated, and individual labs, learning becomes more comfortable. Our experts give 1:1 guidance to each student, which enables overall improvement in each particular section. <br /> With the best study material and teaching instructors, all of our students get help in focusing on their weak areas and improve. Strategies devised individually for every student helps them in achieving the score they want. PTE and other language exams are challenging, but with the right guidance and personalized attention, any student can ace them. We have the highest success rate in PTE Training in Sydney across all of Australia, and we are very proud of it.
                          </li>
                        </ul>                       
                      </div>
                      <div className="pte-bottom-content">
                        <div>
                          <div onClick={this.handleClick} className="d-flex justify-content-center align-items-center">
                            <h3 className="m-0">
                              <a href="javascript:void(0)" className='text-decoration-none'>Read More</a>
                            </h3>
                            <img
                              src="/images/web-new-images/icons/bottom-arrow-01.png"
                              alt="LA"
                            />
                          </div>
                          <ul className={`hide-content ${this.state.isActive ? "active" : ""}`}>                             
                            <li>
                              <h4 className='pte-bottom-heading'>Sydney is the Second-best Place in the World to Study!</h4>
                              English Skills are the primary requirement to thrive in an English-speaking country like Australia. Language Academy is a committed and dedicated PTE Coaching in Sydney and recognized among the PTE Coaching Classes in Sydney that help to achieve the big dream to get the Australian PR.
                            </li>   
                            <li>Sydney is among the top choices of all kinds of local and migrating students. This city gives anyone a mixed feeling of an exciting and carefree lifestyle. The beautiful sand beaches situated just a few kilometres far along the coastline of the intensely stirring city are peaceful to spend a weekend. For students moving from elsewhere, the city has a lot to make them fond of it.</li>                                                   
                            <li>
                              <h4 className='pte-bottom-heading'>The PTE Classes in Sydney CBD</h4>
                              <span>        
                              Whether you are planning on                   
                              <br />
                              - Migrating to Sydney, Australia
                              <br />
                              - Studying in Sydney, Australia
                              <br />
                              - Working in Sydney Australia
                              </span>
                            </li>
                            <li>PTE assessment rewards the learners of English who are not native English speakers but speakers of other languages. It has two types - General and Academic that both help people to prove their English proficiency as non-native speakers and claim candidacy for permanent residency of Australia.</li>
                            <li>PTE Score is accepted by all Universities, helping students willing to continue their higher studies in Australia to move easily. It is also taken by major professional bodies and visa application approval authorities, making it easier to get a PR.</li>
                          </ul>
                        </div>
                      </div>
                      <div className="text-center">
                      <Link to="/auth/register" className="primary-btn">REGISTER NOW <img src="/images/web-new-images/right-arrow.svg" alt="Register Now" /></Link>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
        </div>
        <div className="exam-pattern-section pte-exam-pattern pcs-exam-pattern pt-0">
                <div className="container">
                  <div className="row">                  
                  <h2 className="primary-heading text-center">
                Why choose <br className='d-block' /> Language Academy <br className='d-block' /> <span className="wpl-badge pte-naati-badge text-white">PTE Coaching</span> Classes Training</h2> 	  
                    <div className="pattern-cards-outer">
                        <div className="exam-pattern-cards position-relative">                
                          <Slider {...customslider}>
                            <div>                     
                              <div className="exam-pattern-card">
                                <div className="img-wrapper">
                                  <img
                                    src="/images/web-new-images/icons/speaking-icon.svg"
                                    alt="LA"
                                  />
                                </div>
                                <h3 className="card-title">Experienced Trainer</h3>
                                <p>
                                Our Pearson certified faculties help you to use their expertise in improving your reading, writing, listening, and speaking sections for Online PTE.
                                </p>                      
                              </div>                    
                            </div>
                            <div>                      
                              <div className="exam-pattern-card">
                                <div className="img-wrapper">
                                  <img
                                    src="/images/web-new-images/icons/speaking-icon.svg"
                                    alt="LA"
                                  />
                                </div>
                                <h3 className="card-title">Highest Success Rate </h3>
                                <p>We continuously involve personally with every student, which enables them to unleash the potential in them and achieve the highest scores possible.
                              </p>                      
                              </div>                
                            </div>
                            <div>                    
                              <div className="exam-pattern-card">
                                <div className="img-wrapper">
                                  <img
                                    src="/images/web-new-images/icons/speaking-icon.svg"
                                    alt="LA"
                                  />
                                </div>
                                <h3 className="card-title">Free Books</h3>
                                <p>
                                Free Templates Every student at the Language Academy gets proven templates to study and understand the best way to write an essay and leave the best impression.
                              </p>                      
                              </div>                       
                            </div>
                            <div>                     
                              <div className="exam-pattern-card">
                                <div className="img-wrapper">
                                  <img
                                    src="/images/web-new-images/icons/speaking-icon.svg"
                                    alt="LA"
                                  />
                                </div>
                                <h3 className="card-title">Latest Resources</h3>
                                <p>Students can easily access the study material and take practice tests through our mobile app. Just in a few taps, they can get started.</p>                      
                              </div>                      
                            </div>
                            <div>                     
                              <div className="exam-pattern-card">
                                <div className="img-wrapper">
                                  <img
                                    src="/images/web-new-images/icons/speaking-icon.svg"
                                    alt="LA"
                                  />
                                </div>
                                <h3 className="card-title">Online Support</h3>
                                <p>During the entire class duration, our experts can be reached out to seek any help. They will answer all your questions and help you anywhere you stuck.</p>                      
                              </div>                      
                            </div>
                            <div>                     
                              <div className="exam-pattern-card">
                                <div className="img-wrapper">
                                  <img
                                    src="/images/web-new-images/icons/speaking-icon.svg"
                                    alt="LA"
                                  />
                                </div>
                                <h3 className="card-title">3500 + Questions to Practice</h3>
                                <p>We have curated several previous question papers to help our students in practicing the common questions that are asked frequently.</p>                      
                              </div>                      
                            </div>
                            <div>                     
                              <div className="exam-pattern-card">
                                <div className="img-wrapper">
                                  <img
                                    src="/images/web-new-images/icons/speaking-icon.svg"
                                    alt="LA"
                                  />
                                </div>
                                <h3 className="card-title">Discussion Sessions</h3>
                                <p>Our experts note the weaknesses and strengths of students during the discussion sessions to devise personalized study plans for them.</p>                      
                              </div>                      
                            </div>
                            <div>                     
                              <div className="exam-pattern-card">
                                <div className="img-wrapper">
                                  <img
                                    src="/images/web-new-images/icons/speaking-icon.svg"
                                    alt="LA"
                                  />
                                </div>
                                <h3 className="card-title">Affordable Fees</h3>
                                <p>Our costs are pocket-friendly so the students can easily pay off their fees and improve their score.</p>                      
                              </div>                      
                            </div>
                            <div>                     
                              <div className="exam-pattern-card">
                                <div className="img-wrapper">
                                  <img
                                    src="/images/web-new-images/icons/speaking-icon.svg"
                                    alt="LA"
                                  />
                                </div>
                                <h3 className="card-title">Real Time Test Environment</h3>
                                <p>Our mock tests provide the students with the actual experience of taking tests. Students can test their reading, listening, and writing skills.</p>                      
                              </div>                      
                            </div>
                          </Slider>
                        </div>
                        <div className="text-center">
                          <Link to="/auth/register" className="dark-border primary-btn">
                            REGISTER NOW <img src="/images/web-new-images/right-arrow.svg" alt="Register Now" />
                          </Link>
                        </div>
                    </div>
                  </div>
                </div>
        </div>  
        <div className='pcs-video-section'>
          <VideoTestimonial title="PTE Success Stories" />
        </div>
        <FameWallPte />      
        <div className="numbers-section pcs-section">
                  <div className="container">
                    <div className="row">                  
                      <div className="col-md-6 col-lg-3">
                        <div className="number-card-outer">
                          <div className="number-card">
                            <div className="number-card-content">
                              <div className="img-wrapper-outer">
                                <div className="img-wrapper">
                                  <img
                                    src="/images/web-new-images/icons/11.svg"
                                    alt="LA"
                                  />
                                </div>
                              </div>
                              <h3 className="card-title">10,000+</h3>
                              <p className="card-sub-title">Students Taught</p>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="col-md-6 col-lg-3">
                        <div className="number-card-outer">
                          <div className="number-card">
                            <div className="number-card-content">
                              <div className="img-wrapper-outer">
                                <div className="img-wrapper">
                                  <img
                                    src="/images/web-new-images/icons/11.svg"
                                    alt="LA"
                                  />
                                </div>
                              </div>
                              <h3 className="card-title">5,000+</h3>
                              <p className="card-sub-title">Students Scored 79+</p>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="col-md-6 col-lg-3">
                        <div className="number-card-outer">
                          <div className="number-card">
                            <div className="number-card-content">
                              <div className="img-wrapper-outer">
                                <div className="img-wrapper">
                                  <img
                                    src="/images/web-new-images/icons/11.svg"
                                    alt="LA"
                                  />
                                </div>
                              </div>
                              <h3 className="card-title">100+</h3>
                              <p className="card-sub-title">Online Success Stories</p>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="col-md-6 col-lg-3">
                        <div className="number-card-outer">
                          <div className="number-card">
                            <div className="number-card-content">
                              <div className="img-wrapper-outer">
                                <div className="img-wrapper">
                                  <img
                                    src="/images/web-new-images/icons/11.svg"
                                    alt="LA"
                                  />
                                </div>
                              </div>
                              <h3 className="card-title">8,000+</h3>
                              <p className="card-sub-title">Total Success Stories</p>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="text-center col-lg-12">
                        <Link to="/auth/register" className="primary-btn">
                          REGISTER NOW{" "}
                          <img
                            src="/images/web-new-images/right-arrow.svg"
                            alt="Register Now"
                          />
                        </Link>
                      </div>
                    </div>
                  </div>
        </div>
        <Testimonial />  
        <div className='pcs-videos-tutorial'>          
          <VideoTuts />
        </div>      
        <div className="faq-section">
        <div className="container">
          <div className="row">
            <h2 className="secondary-heading text-center">
              Frequently Asked Questions
            </h2>
            <div className="accordion" id="accordionExample">
              <div className="accordion-item">
                <h2 className="accordion-header" id="headingOne">
                  <button
                    className="accordion-button"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#collapseOne"
                    aria-expanded="true"
                    aria-controls="collapseOne"
                  >
                    What is the recommended number of PTE mock tests that I should undertake?
                  </button>
                </h2>
                <div
                  id="collapseOne"
                  className="accordion-collapse collapse show"
                  aria-labelledby="headingOne"
                  data-bs-parent="#accordionExample"
                >
                  <div className="accordion-body">
                  It is recommended to take three complete PTE mock tests.
                  </div>
                </div>
              </div>
              <div className="accordion-item">
                <h2 className="accordion-header" id="headingTwo">
                  <button
                    className="accordion-button collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#collapseTwo"
                    aria-expanded="false"
                    aria-controls="collapseTwo"
                  >
                    What is the PTE requirement for canada?
                  </button>
                </h2>
                <div
                  id="collapseTwo"
                  className="accordion-collapse collapse"
                  aria-labelledby="headingTwo"
                  data-bs-parent="#accordionExample"
                >
                  <div className="accordion-body">
                  The minimum PTE score for Bachelor's programs, Advanced Diplomas, and Post Graduate Programs is 60, with a minimum band score of 53. Students with an overall score of 56 and each band score of at least 51 have also been granted study permits.
                  </div>
                </div>
              </div>
              <div className="accordion-item">
                <h2 className="accordion-header" id="headingThree">
                  <button
                    className="accordion-button collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#collapseThree"
                    aria-expanded="false"
                    aria-controls="collapseThree"
                  >
                    What is the duration of a full-length PTE mock test?
                  </button>
                </h2>
                <div
                  id="collapseThree"
                  className="accordion-collapse collapse"
                  aria-labelledby="headingThree"
                  data-bs-parent="#accordionExample"
                >
                  <div className="accordion-body">
                  Around 2 hours. Students can attempt the test in one go or by taking short breaks.
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        </div>
      <Footer />
    </React.Fragment>);
    }
}

export default Pte;
